import Small from 'UIComponents/elements/Small';
import WalmartFilterPropertyEvaluationValue from 'flow-doctor-lib/components/filters/WalmartFilterPropertyEvaluationValue';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartFilterEvaluationValue = ({
  evaluationData,
  objectTypeId
}) => {
  // Only PropertyValue is supported for now
  if (evaluationData.length === 0 || evaluationData[0].dataType !== 'PropertyValue') {
    return null;
  }
  const evalData = evaluationData[0];
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(WalmartFilterPropertyEvaluationValue, {
        evaluationData: evalData,
        objectTypeId: objectTypeId
      })
    })
  });
};
export default WalmartFilterEvaluationValue;